import { ActionTypes, ChangeStationActivityActions } from './change-station-activity.actions';
import { ChangeStationActivityState } from './change-station-activity.model';

export const changeStationActivityState: ChangeStationActivityState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getChangeStationActivityLoading: false,
  getChangeStationActivityLoaded: false,
  changeStationActivity: null,
  addChangeStationActivityLoading: false,
  addChangeStationActivityLoaded: false,
  editChangeStationActivityLoading: false,
  editChangeStationActivityLoaded: false,
  deleteChangeStationActivitiesLoading: false,
  deleteChangeStationActivitiesLoaded: false,
  activitiesDataLoading: false,
  activitiesDataLoaded: false,
  activitiesData: [],
  tasksDataLoading: false,
  tasksDataLoaded: false,
  tasksData: [],
  extendedTasksDataLoading: false,
  extendedTasksDataLoaded: false,
  extendedTasksData: [],
  lineDestinationsDataLoading: false,
  lineDestinationsDataLoaded: false,
  lineDestinationsData: [],
  cleanerRulesDataLoading: false,
  cleanerRulesDataLoaded: false,
  cleanerRulesData: [],
  taskLookupDataLoading: false,
  taskLookupDataLoaded: false,
  taskLookupData: [],
};

export function changeStationActivityReducer(
  state: ChangeStationActivityState = changeStationActivityState,
  action: ChangeStationActivityActions,
): ChangeStationActivityState {
  switch (action.type) {
    case ActionTypes.CHANGE_STATION_ACTIVITYS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.CHANGE_STATION_ACTIVITYS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_CHANGE_STATION_ACTIVITY:
      return {
        ...state,
        getChangeStationActivityLoading: true,
        getChangeStationActivityLoaded: false,
      };
    case ActionTypes.GET_CHANGE_STATION_ACTIVITY_COMPLETED:
      return {
        ...state,
        changeStationActivity: action.payload.data,
        getChangeStationActivityLoading: false,
        getChangeStationActivityLoaded: true,
      };
    case ActionTypes.ADD_CHANGE_STATION_ACTIVITY:
      return {
        ...state,
        addChangeStationActivityLoading: true,
        addChangeStationActivityLoaded: false,
      };
    case ActionTypes.ADD_CHANGE_STATION_ACTIVITY_COMPLETED:
      return {
        ...state,
        addChangeStationActivityLoading: false,
        addChangeStationActivityLoaded: true,
      };
    case ActionTypes.EDIT_CHANGE_STATION_ACTIVITY:
      return {
        ...state,
        editChangeStationActivityLoading: true,
        editChangeStationActivityLoaded: false,
      };
    case ActionTypes.EDIT_CHANGE_STATION_ACTIVITY_COMPLETED:
      return {
        ...state,
        editChangeStationActivityLoading: false,
        editChangeStationActivityLoaded: true,
      };
    case ActionTypes.DELETE_CHANGE_STATION_ACTIVITYS:
      return {
        ...state,
        deleteChangeStationActivitiesLoading: true,
        deleteChangeStationActivitiesLoaded: false,
      };
    case ActionTypes.DELETE_CHANGE_STATION_ACTIVITYS_COMPLETED:
      return {
        ...state,
        deleteChangeStationActivitiesLoading: false,
        deleteChangeStationActivitiesLoaded: true,
      };
    case ActionTypes.ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        activitiesDataLoading: true,
        activitiesDataLoaded: false,
      };
    case ActionTypes.ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        activitiesData: action.payload,
        activitiesDataLoading: false,
        activitiesDataLoaded: true,
      };
    case ActionTypes.TASKS_DATA_LOADING:
      return {
        ...state,
        tasksDataLoading: true,
        tasksDataLoaded: false,
      };
    case ActionTypes.TASKS_DATA_COMPLETED:
      return {
        ...state,
        tasksData: action.payload,
        tasksDataLoading: false,
        tasksDataLoaded: true,
      };
    case ActionTypes.EXTENDED_TASKS_DATA_LOADING:
      return {
        ...state,
        extendedTasksDataLoading: true,
        extendedTasksDataLoaded: false,
      };
    case ActionTypes.EXTENDED_TASKS_DATA_COMPLETED:
      return {
        ...state,
        extendedTasksData: action.payload,
        extendedTasksDataLoading: false,
        extendedTasksDataLoaded: true,
      };
    case ActionTypes.LINE_DESTINATIONS_DATA_LOADING:
      return {
        ...state,
        lineDestinationsDataLoading: true,
        lineDestinationsDataLoaded: false,
      };
    case ActionTypes.LINE_DESTINATIONS_DATA_COMPLETED:
      return {
        ...state,
        lineDestinationsData: action.payload,
        lineDestinationsDataLoading: false,
        lineDestinationsDataLoaded: true,
      };
    case ActionTypes.CLEANER_RULES_DATA_LOADING:
      return {
        ...state,
        cleanerRulesDataLoading: true,
        cleanerRulesDataLoaded: false,
      };
    case ActionTypes.CLEANER_RULES_DATA_COMPLETED:
      return {
        ...state,
        cleanerRulesData: action.payload,
        cleanerRulesDataLoading: false,
        cleanerRulesDataLoaded: true,
      };
    case ActionTypes.TASK_LOOKUP_DATA_LOADING:
      return {
        ...state,
        taskLookupDataLoading: true,
        taskLookupDataLoaded: false,
      };
    case ActionTypes.TASK_LOOKUP_DATA_COMPLETED:
      return {
        ...state,
        taskLookupData: action.payload,
        taskLookupDataLoading: false,
        taskLookupDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
